import type { ApiClient } from "@/modules/api/apiClient.ts";
import { getResponseData } from "@/modules/api/apiClient.ts";
import { userIsAdminAtom } from "@/modules/user/userApi.ts";
import { mergeLoadedQueries } from "@/utils/query/mergeQueries.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { queryOptions, type QueryKey } from "@tanstack/react-query";
import type { VmCustomImage } from "@warrenio/api-spec/spec.oats.gen";
import { atom } from "jotai/vanilla";

type Response = VmCustomImage[];

const queryKey: QueryKey = ["custom_images"];

function getQuery(client: ApiClient) {
    return queryOptions({
        queryKey,
        queryFn: async ({ signal }): Promise<Response> => {
            return getResponseData(await client.GET("/config/boot_images", { signal }));
        },
    });
}

const allCustomImagesQueryAtom = atomFromStandardQueryOptions(getQuery);

function getAvailableCustomImages(images: VmCustomImage[], isAdmin: boolean): VmCustomImage[] {
    const visibleImageVersions = isAdmin ? images : images.filter((i) => i.is_published);
    return visibleImageVersions;
    // CREATE VIEW
    // return visibleImageVersions.filter((i) => i.is_installation_media);
}

export const availableCustomImagesAtom = atom((get) =>
    mergeLoadedQueries(
        { images: get(allCustomImagesQueryAtom), isAdmin: get(userIsAdminAtom) },
        ({ images, isAdmin }) => {
            return getAvailableCustomImages(images, isAdmin);
        },
    ),
);
